(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inkd-holiday-gifting"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('holiday-gifting-form');
  var success = document.getElementById('holiday-gifting-success');
  if (!form || !success) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var label = submitBtn && submitBtn.querySelector('.v3-btn__label');
    var sendErr = document.getElementById('holiday-gifting-error');
    if (sendErr) sendErr.hidden = true;
    if (submitBtn) submitBtn.disabled = true;
    if (label) label.textContent = 'Sending...';

    fetch('https://holiday.inkdstores.workers.dev/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: document.getElementById('hgName').value.trim(),
        email: document.getElementById('hgEmail').value.trim(),
        store: document.getElementById('hgCompany').value.trim(),
        phone: document.getElementById('hgPhone').value.trim(),
        details: document.getElementById('hgBody').value.trim(),
        page: location.href
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('submit failed');
      form.hidden = true;
      success.hidden = false;
    }).catch(function () {
      if (submitBtn) submitBtn.disabled = false;
      if (label) label.textContent = 'Submit';
      if (sendErr) sendErr.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkd-v2"] && !Shopify.designMode) return;
  try {
    
  const sheet = document.querySelector('.v2-dock__sheet');
  if (sheet) {
    const panel = sheet.querySelector('.v2-dock__links');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let closing = false;

    sheet.classList.add('is-animated');

    const finishClose = () => {
      sheet.removeAttribute('open');
      sheet.classList.remove('is-open', 'is-closing');
      closing = false;
    };

    sheet.addEventListener('toggle', () => {
      if (!sheet.open || closing) return;
      sheet.classList.remove('is-closing');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sheet.classList.add('is-open');
        });
      });
    });

    sheet.querySelector('.v2-dock__toggle').addEventListener('click', (event) => {
      if (!sheet.open || closing) return;
      event.preventDefault();
      if (reduce) {
        finishClose();
        return;
      }
      closing = true;
      sheet.classList.add('is-closing');
      sheet.classList.remove('is-open');
      const done = (event) => {
        if (event && event.target !== panel) return;
        panel.removeEventListener('transitionend', done);
        finishClose();
      };
      panel.addEventListener('transitionend', done);
      setTimeout(done, 360);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkd-v3-hardgoods"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-v3-hg]');
  if (!root) return;

  root.querySelectorAll('.v3-lulu__colors').forEach(function (list) {
    var names = [];
    list.querySelectorAll('li').forEach(function (li) {
      var text = '';
      li.childNodes.forEach(function (node) {
        if (node.nodeType === 3) text += node.textContent;
      });
      text = text.replace(/\s+/g, ' ').trim();
      li.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = '';
      });
      if (text) names.push(text);
    });
    if (!names.length) return;
    var line = document.createElement('p');
    line.className = 'v3-lulu__color-names';
    line.textContent = names.join(' / ');
    list.after(line);
  });

  var groups = root.querySelectorAll('.v3-lulu__group');
  var sectionGrids = [];
  var jumpNav = document.createElement('nav');
  jumpNav.className = 'v3-lulu__jumps';
  jumpNav.setAttribute('aria-label', 'Sections');
  var jumpButtons = [];
  var footButtons = [];
  var currentSection = 0;
  var pagerPrev;
  var pagerNext;
  var footPrev;
  var footNext;

  function markCurrent(list, index) {
    list.forEach(function (button, i) {
      var on = i === index;
      button.classList.toggle('is-current', on);
      if (on) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }

  function setJump(index) {
    markCurrent(jumpButtons, index);
    markCurrent(footButtons, index);
  }

  function syncPager() {
    if (!pagerPrev || !pagerNext) return;
    var prev = jumpButtons[currentSection - 1];
    var next = jumpButtons[currentSection + 1];
    pagerPrev.hidden = !prev;
    pagerNext.hidden = !next;
    if (footPrev) setFootStep(footPrev, !!prev);
    if (footNext) setFootStep(footNext, !!next);
    if (prev) {
      pagerPrev.querySelector('span').textContent = 'Previous';
      pagerPrev.setAttribute('aria-label', 'Previous category, ' + prev.textContent.trim());
      if (footPrev) footPrev.setAttribute('aria-label', 'Previous category, ' + prev.textContent.trim());
    }
    if (next) {
      pagerNext.querySelector('span').textContent = 'Next';
      pagerNext.setAttribute('aria-label', 'Next category, ' + next.textContent.trim());
      if (footNext) footNext.setAttribute('aria-label', 'Next category, ' + next.textContent.trim());
    }
  }

  function showSection(index) {
    currentSection = index;
    setJump(index);
    sectionGrids.forEach(function (grid, i) {
      var on = i === index;
      grid.hidden = !on;
      grid.classList.remove('is-shown');
      if (!on) return;
      void grid.offsetWidth;
      grid.classList.add('is-shown');
    });
    syncPager();
  }

  groups.forEach(function (heading, index) {
    heading.id = 'lulu-sec-' + index;
    var grid = heading.nextElementSibling;
    sectionGrids.push(grid);
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = heading.textContent.trim();
    button.addEventListener('click', function () {
      if (button.classList.contains('is-current')) return;
      showSection(index);
    });
    jumpNav.appendChild(button);
    jumpButtons.push(button);
  });
  var firstPanel = root.querySelector('.v3-lulu__panel');
  if (firstPanel && jumpButtons.length) firstPanel.parentNode.insertBefore(jumpNav, firstPanel);

  var catalog = root.querySelector('.v3-lulu__catalog');
  if (catalog && jumpButtons.length > 1) {
    var pager = document.createElement('div');
    pager.className = 'v3-lulu__pager';
    function makePager(dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'v3-lulu__pager-btn';
      var icon = dir < 0
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>';
      button.innerHTML = dir < 0
        ? icon + '<span></span>'
        : '<span></span>' + icon;
      button.addEventListener('click', function () {
        var next = currentSection + dir;
        if (next < 0 || next >= jumpButtons.length) return;
        showSection(next);
        var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
        if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
        else window.scrollTo(0, Math.max(0, top));
      });
      return button;
    }
    pagerPrev = makePager(-1);
    pagerNext = makePager(1);
    var barSlot = document.getElementById('hgSelectBar');
    var midSlot = barSlot && barSlot.querySelector('.v3-lulu__bar-mid');
    if (barSlot && midSlot) {
      barSlot.insertBefore(pagerPrev, midSlot);
      barSlot.appendChild(pagerNext);
    }
    var footNav = document.createElement('nav');
    footNav.className = 'v3-lulu__jumps v3-lulu__jumps--foot';
    footNav.setAttribute('aria-label', 'Sections');
    groups.forEach(function (heading, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = heading.textContent.trim();
      button.addEventListener('click', function () {
        if (index === currentSection) return;
        showSection(index);
        var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
        if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
        else window.scrollTo(0, Math.max(0, top));
      });
      footNav.appendChild(button);
      footButtons.push(button);
    });
    pager.appendChild(footNav);
    catalog.appendChild(pager);
  }
  if (jumpButtons.length) showSection(0);

  root.querySelectorAll('[data-hg-browse]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
  });

  var bar = document.getElementById('hgSelectBar');
  var grids = root.querySelectorAll('.v3-lulu__grid');
  if (bar && grids.length) {
    var barTicking = false;
    function syncBar() {
      var line = window.innerHeight * 0.62;
      var floor = window.innerHeight * 0.18;
      var show = false;
      grids.forEach(function (grid) {
        if (grid.hidden || grid.closest('[hidden]')) return;
        var rect = grid.getBoundingClientRect();
        if (rect.top < line && rect.bottom > floor) show = true;
      });
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function onScroll() {
      if (barTicking) return;
      barTicking = true;
      requestAnimationFrame(function () {
        barTicking = false;
        syncBar();
      });
    }
    syncBar();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    function bindLenis(tries) {
      if (window.lenis && window.lenis.on) window.lenis.on('scroll', onScroll);
      else if (tries > 0) setTimeout(function () { bindLenis(tries - 1); }, 200);
    }
    bindLenis(15);
  }

  var cards = root.querySelectorAll('.v3-lulu__grid > li');
  var selected = new Set();
  var MAX = 24;
  var countEl = document.getElementById('hgCount');
  var addBtn = document.getElementById('hgAddSelected');
  var finishBtn = null;
  var pagerEl = root.querySelector('.v3-lulu__pager');
  if (addBtn && pagerEl) {
    finishBtn = addBtn.cloneNode(true);
    finishBtn.id = 'hgFinish';
    var finishLabel = finishBtn.querySelector('.v3-btn__label');
    if (finishLabel) finishLabel.textContent = 'Finish selection';
    var finishWrap = document.createElement('div');
    finishWrap.className = 'v3-lulu__finish';
    footPrev = document.createElement('button');
    footPrev.type = 'button';
    footPrev.className = 'v3-btn v3-lulu__finish-next v3-lulu__finish-prev';
    footPrev.textContent = 'Previous';
    footPrev.addEventListener('click', function () {
      var prev = currentSection - 1;
      if (prev < 0) return;
      showSection(prev);
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
    finishWrap.appendChild(footPrev);
    finishWrap.appendChild(finishBtn);
    footNext = document.createElement('button');
    footNext.type = 'button';
    footNext.className = 'v3-btn v3-lulu__finish-next';
    footNext.textContent = 'Next';
    footNext.addEventListener('click', function () {
      var next = currentSection + 1;
      if (next >= jumpButtons.length) return;
      showSection(next);
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
    finishWrap.appendChild(footNext);
    setFootStep(footPrev, currentSection > 0);
    setFootStep(footNext, currentSection < jumpButtons.length - 1);
    pagerEl.appendChild(finishWrap);
    var bulk = document.createElement('p');
    bulk.className = 'v3-lulu__bulk';
    bulk.innerHTML = 'Want to order more than 12? <a href="mailto:rich@inkdstores.com?subject=Bulk%20pricing&amp;body=We%20want%20to%20order%20more%20than%2012%20hard%20goods.">Contact us for Bulk Pricing</a>';
    pagerEl.appendChild(bulk);
  }

  function setFootStep(button, show) {
    if (!button) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      button.hidden = !show;
      button.classList.toggle('is-in', show);
      button.classList.remove('is-out');
      return;
    }
    if (show) {
      var staying = button.classList.contains('is-in') && !button.classList.contains('is-out') && !button.hidden;
      button.hidden = false;
      button.classList.remove('is-out');
      if (staying) return;
      void button.offsetWidth;
      button.classList.add('is-in');
      return;
    }
    if (button.hidden || button.classList.contains('is-out') || !button.classList.contains('is-in')) {
      button.hidden = true;
      return;
    }
    button.classList.remove('is-in');
    button.classList.add('is-out');
    var token = {};
    button._leave = token;
    button.addEventListener('transitionend', function done(event) {
      if (event.propertyName !== 'opacity' || button._leave !== token) return;
      button.hidden = true;
      button.classList.remove('is-out');
      button.removeEventListener('transitionend', done);
    });
  }

  var galIcon = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>'
  };

  cards.forEach(function (card, index) {
    card.classList.add('v3-lulu__shot');
    card.setAttribute('role', 'button');
    card.tabIndex = 0;
    card.setAttribute('aria-pressed', 'false');
    card.setAttribute('data-id', String(index + 1));
    card.querySelectorAll('.hg-gal').forEach(function (btn) {
      btn.innerHTML = btn.classList.contains('hg-gal--prev') ? galIcon.prev : galIcon.next;
    });
    if (card.querySelector('.hg-gal')) syncGallery(card);
    var photo = card.querySelector('.v3-lulu__img');
    if (photo && !photo.querySelector('.v3-lulu__picked')) {
      var mark = document.createElement('span');
      mark.className = 'v3-lulu__picked';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = 'Selected';
      photo.appendChild(mark);
    }
  });

  function cardName(card) {
    var strong = card.querySelector('strong');
    var base = strong ? strong.textContent.trim() : '';
    var on = card.querySelector('.v3-lulu__colors li.is-on');
    var color = on ? on.getAttribute('data-color') : '';
    return color ? base + ' — ' + color : base;
  }

  function syncGallery(card) {
    var items = card.querySelectorAll('.v3-lulu__colors li[data-src]');
    var index = Number(card.getAttribute('data-variant') || '0');
    var prev = card.querySelector('.hg-gal--prev');
    var next = card.querySelector('.hg-gal--next');
    if (prev) prev.hidden = index <= 0;
    if (next) next.hidden = index >= items.length - 1;
  }

  function showVariant(card, index) {
    var items = card.querySelectorAll('.v3-lulu__colors li[data-src]');
    if (!items.length || index < 0 || index >= items.length) return;
    var item = items[index];
    var img = card.querySelector('.v3-lulu__img img');
    if (img) {
      img.src = item.getAttribute('data-src');
      var alt = item.getAttribute('data-alt');
      if (alt) img.alt = alt;
    }
    items.forEach(function (el, i) {
      el.classList.toggle('is-on', i === index);
    });
    card.setAttribute('data-variant', String(index));
    syncGallery(card);
  }

  function updateCount() {
    var n = selected.size;
    var bulkMail = 'mailto:rich@inkdstores.com?subject=Bulk%20pricing&body=We%20want%20to%20order%20more%20than%2012%20hard%20goods.';
    if (countEl) {
      countEl.classList.toggle('is-wide', n >= 12);
      if (n === 0) {
        countEl.textContent = 'Click a product to select it, up to 12.';
      } else if (n === 12) {
        countEl.textContent = 'Finished. 12 items selected, click Finish selection.';
      } else if (n === MAX) {
        countEl.innerHTML = '24 items selected. Please <a href="' + bulkMail + '">email us</a> if you want more.';
      } else if (n > 12) {
        countEl.innerHTML = n + ' items selected. Want to order more than 12? <a href="' + bulkMail + '">Contact us for Bulk Pricing</a>';
      } else {
        countEl.textContent = n + (n === 1 ? ' item selected' : ' items selected');
      }
    }
    [addBtn, finishBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('is-disabled', n === 0);
      btn.disabled = n === 0;
    });
  }

  function toggle(card) {
    var id = card.getAttribute('data-id');
    if (selected.has(id)) {
      selected.delete(id);
      card.classList.remove('is-selected');
      void card.offsetWidth;
      card.classList.add('is-leaving');
      card.setAttribute('aria-pressed', 'false');
    } else if (selected.size < MAX) {
      selected.add(id);
      card.classList.remove('is-leaving');
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      updateCount();
      if (selected.size === 1 || selected.size % 6 === 0) nudgeSend();
      return;
    }
    updateCount();
  }

  function nudgeSend() {
    [addBtn, finishBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.remove('v3-lulu__nudge');
      void btn.offsetWidth;
      btn.classList.add('v3-lulu__nudge');
    });
  }

  function resetRow(grid) {
    Array.prototype.forEach.call(grid.children, function (el) {
      if (el.tagName === 'LI') el.style.flexBasis = '';
    });
  }

  function layoutRow(card) {
    var grid = card.closest('.v3-lulu__grid');
    if (!grid) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var top = card.offsetTop;
    var mates = [];
    Array.prototype.forEach.call(grid.children, function (el) {
      if (el.tagName !== 'LI') return;
      if (Math.abs(el.offsetTop - top) < 4) mates.push(el);
      else el.style.flexBasis = '';
    });
    var n = mates.length;
    if (n < 2) {
      mates.forEach(function (el) { el.style.flexBasis = ''; });
      return;
    }
    var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
    var grow = 1.34;
    var gaps = (n - 1) * gap;
    mates.forEach(function (el) {
      var weight = el === card ? grow : (n - grow) / (n - 1);
      el.style.flexBasis = 'calc((100% - ' + gaps + 'px - 2px) * ' + (weight / n).toFixed(4) + ')';
    });
  }

  root.addEventListener('pointerover', function (event) {
    var card = event.target.closest('.v3-lulu__shot');
    if (!card || !root.contains(card)) return;
    if (card.contains(event.relatedTarget)) return;
    layoutRow(card);
    var desc = card.querySelector('.hg-desc');
    if (!desc) return;
    var rect = card.getBoundingClientRect();
    desc.classList.toggle('is-left', window.innerWidth - rect.right < 280);
  });

  root.querySelectorAll('.v3-lulu__grid').forEach(function (grid) {
    grid.addEventListener('pointerleave', function () {
      resetRow(grid);
    });
  });

  root.addEventListener('click', function (event) {
    var card = event.target.closest('.v3-lulu__shot');
    if (!card || !root.contains(card)) return;
    if (event.target.closest('.hg-desc')) return;
    if (event.target.closest('.hg-gal, .v3-lulu__colors')) {
      var items = card.querySelectorAll('.v3-lulu__colors li[data-src]');
      var current = Number(card.getAttribute('data-variant') || '0');
      if (event.target.closest('.hg-gal--next')) showVariant(card, current + 1);
      else if (event.target.closest('.hg-gal--prev')) showVariant(card, current - 1);
      else {
        var swatch = event.target.closest('.v3-lulu__colors li');
        if (swatch) showVariant(card, Array.prototype.indexOf.call(items, swatch));
      }
      event.preventDefault();
      return;
    }
    toggle(card);
  });

  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target.closest('.hg-gal, .v3-lulu__colors')) return;
    var card = event.target.closest('.v3-lulu__shot');
    if (!card) return;
    event.preventDefault();
    toggle(card);
  });

  var formLayer = document.getElementById('hgForm');
  var form = document.getElementById('hgContact');
  var formWrap = document.getElementById('hgFormWrap');
  var success = document.getElementById('hgSuccess');
  var lede = document.getElementById('hgFormLede');
  var picker = document.getElementById('hgPicker');
  var formCount = document.getElementById('hgFormCount');
  var progress = document.getElementById('hgProgress');
  var progressFill = document.getElementById('hgProgressFill');
  var nextBtn = document.getElementById('hgNext');
  var formSteps = formLayer ? formLayer.querySelectorAll('.v3-lulu__step') : [];
  var stepLabels = formLayer ? formLayer.querySelectorAll('.v3-lulu__steps span') : [];
  var mode = 'selected';
  var formSelected = new Set();
  var currentStep = 1;

  function cardGroup(card) {
    var grid = card.closest('.v3-lulu__grid');
    var heading = grid && grid.previousElementSibling;
    return heading ? heading.textContent.trim() : 'Collection';
  }

  function cardImage(card) {
    var img = card.querySelector('img');
    return img ? img.getAttribute('src') : '';
  }

  function formCards() {
    var list = [];
    cards.forEach(function (card) {
      var id = card.getAttribute('data-id');
      if (mode === 'full' || selected.has(id)) list.push(card);
    });
    return list;
  }

  function syncFormCount() {
    var n = formSelected.size;
    if (formCount) formCount.textContent = n + '/' + MAX;
    if (nextBtn) nextBtn.disabled = n === 0;
  }

  function paintCard(card, on) {
    var id = card.getAttribute('data-id');
    if (on) {
      selected.add(id);
      card.classList.add('is-selected');
      card.classList.remove('is-leaving');
      card.setAttribute('aria-pressed', 'true');
    } else {
      selected.delete(id);
      card.classList.remove('is-selected');
      card.classList.add('is-leaving');
      card.setAttribute('aria-pressed', 'false');
    }
  }

  function renderPicker() {
    if (!picker) return;
    picker.innerHTML = '';
    var groups = [];
    var byName = {};
    cards.forEach(function (card) {
      var group = cardGroup(card);
      if (!byName[group]) {
        byName[group] = [];
        groups.push(group);
      }
      byName[group].push(card);
    });
    groups.forEach(function (group) {
      var items = byName[group].filter(function (card) {
        return formSelected.has(card.getAttribute('data-id'));
      });
      if (!items.length) return;
      var block = document.createElement('section');
      block.className = 'v3-lulu__pick-group is-open';
      var head = document.createElement('div');
      head.className = 'v3-lulu__pick-head';
      var toggle = document.createElement('div');
      toggle.className = 'v3-lulu__pick-toggle';
      var title = document.createElement('span');
      title.textContent = group;
      var tally = document.createElement('span');
      function groupOn() {
        return items.filter(function (card) {
          return formSelected.has(card.getAttribute('data-id'));
        }).length;
      }
      function writeTally() {
        tally.textContent = String(groupOn());
      }
      var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chevron.setAttribute('class', 'v3-lulu__pick-chevron');
      chevron.setAttribute('viewBox', '0 0 24 24');
      chevron.setAttribute('fill', 'none');
      chevron.setAttribute('aria-hidden', 'true');
      var chevronPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      chevronPath.setAttribute('d', 'M6 9l6 6 6-6');
      chevronPath.setAttribute('stroke', 'currentColor');
      chevronPath.setAttribute('stroke-width', '1.8');
      chevronPath.setAttribute('stroke-linecap', 'square');
      chevron.appendChild(chevronPath);
      var name = document.createElement('span');
      name.className = 'v3-lulu__pick-name';
      name.appendChild(title);
      name.appendChild(chevron);
      toggle.appendChild(name);
      toggle.appendChild(tally);
      head.appendChild(toggle);
      block.appendChild(head);
      items.forEach(function (card) {
        var id = card.getAttribute('data-id');
        var label = document.createElement('label');
        label.className = 'v3-lulu__pick';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = formSelected.has(id);
        cb.addEventListener('change', function () {
          if (cb.checked) {
            cb.checked = false;
            return;
          }
          formSelected.delete(id);
          if (mode === 'selected') {
            paintCard(card, false);
            updateCount();
          }
          label.remove();
          if (groupOn() === 0) block.remove();
          else writeTally();
          syncFormCount();
        });
        var img = document.createElement('img');
        img.src = cardImage(card);
        img.alt = '';
        img.width = 44;
        img.height = 56;
        var span = document.createElement('span');
        span.textContent = cardName(card);
        label.appendChild(cb);
        label.appendChild(img);
        label.appendChild(span);
        block.appendChild(label);
      });
      writeTally();
      picker.appendChild(block);
    });
    syncFormCount();
  }

  function setStep(n) {
    currentStep = n;
    formSteps.forEach(function (step) {
      step.hidden = step.getAttribute('data-step') !== String(n);
    });
    if (nextBtn) nextBtn.hidden = n === 2;
    var submitBtn = document.getElementById('hgSubmit');
    if (submitBtn) submitBtn.hidden = n !== 2;
    if (formCount) formCount.hidden = n !== 1;
    if (progressFill) progressFill.style.width = (n === 1 ? '50%' : '100%');
    stepLabels.forEach(function (label, i) {
      label.classList.toggle('is-active', i < n);
    });
    if (formLayer) formLayer.scrollTop = 0;
  }

  function openForm(kind) {
    if (kind === 'selected' && selected.size === 0) return;
    mode = kind;
    formSelected = new Set();
    formCards().forEach(function (card) {
      formSelected.add(card.getAttribute('data-id'));
    });
    if (lede) {
      lede.textContent = 'Uncheck any piece you want to leave out.';
    }
    renderPicker();
    setStep(1);
    if (formWrap) formWrap.hidden = false;
    if (success) success.hidden = true;
    if (progress) progress.hidden = false;
    var intro = document.getElementById('hgFormIntro');
    if (intro) intro.hidden = false;
    if (formLayer) {
      formLayer.hidden = false;
      document.body.classList.add('v3-lulu-form-open');
    }
  }

  function closeForm() {
    if (formLayer) formLayer.hidden = true;
    document.body.classList.remove('v3-lulu-form-open');
  }

  root.querySelectorAll('[data-hg-open]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openForm(btn.getAttribute('data-hg-open'));
    });
  });

  var backBtn = document.getElementById('hgFormBack');
  var successClose = document.getElementById('hgSuccessClose');
  if (backBtn) backBtn.addEventListener('click', function () {
    if (currentStep > 1) {
      clearErrors();
      setStep(1);
      return;
    }
    closeForm();
  });
  if (successClose) successClose.addEventListener('click', closeForm);
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (formSelected.size === 0) return;
    setStep(2);
  });

  function clearErrors() {
    root.querySelectorAll('.v3-lulu__field.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });
  }

  function validate() {
    clearErrors();
    var name = document.getElementById('hgName').value.trim();
    var email = document.getElementById('hgEmail').value.trim();
    var store = document.getElementById('hgStore').value.trim();
    var ok = true;
    if (!name) { document.getElementById('hgNameField').classList.add('is-error'); ok = false; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      document.getElementById('hgEmailField').classList.add('is-error');
      ok = false;
    }
    if (!store) { document.getElementById('hgStoreField').classList.add('is-error'); ok = false; }
    return ok;
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (currentStep === 1) {
        if (formSelected.size === 0) return;
        setStep(2);
        return;
      }
      if (!validate()) return;
      var name = document.getElementById('hgName').value.trim();
      var email = document.getElementById('hgEmail').value.trim();
      var store = document.getElementById('hgStore').value.trim();
      var items = [];
      var lines = [];
      var lastGroup = '';
      formCards().forEach(function (card) {
        var id = card.getAttribute('data-id');
        if (!formSelected.has(id)) return;
        var nameLine = cardName(card);
        var group = cardGroup(card);
        items.push(group + ' — ' + nameLine);
        if (group !== lastGroup) {
          if (lines.length) lines.push('');
          lines.push(group);
          lastGroup = group;
        }
        lines.push('- ' + nameLine);
      });
      var details = (mode === 'full' ? 'Full collection' : 'Selected pieces') + ' (' + items.length + '):\n' + lines.join('\n') + '\n\n'
        + 'Name: ' + name + '\n'
        + 'Email: ' + email + '\n'
        + 'Webstore / Company: ' + store;
      var submitBtn = document.getElementById('hgSubmit');
      var label = submitBtn.querySelector('.v3-btn__label');
      var sendErr = document.getElementById('hgSubmitError');
      submitBtn.disabled = true;
      if (label) label.textContent = 'Sending...';
      if (sendErr) sendErr.hidden = true;

      var body = document.getElementById('hgBody');
      if (body) body.value = 'Branded goods webstore request\n\n' + details + '\nPage: ' + location.href;
      HTMLFormElement.prototype.submit.call(form);
    });
  }

  updateCount();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkd-v3-lululemon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-v3-lulu]');
  if (!root) return;

  root.querySelectorAll('.v3-lulu__colors').forEach(function (list) {
    var names = [];
    list.querySelectorAll('li').forEach(function (li) {
      var text = '';
      li.childNodes.forEach(function (node) {
        if (node.nodeType === 3) text += node.textContent;
      });
      text = text.replace(/\s+/g, ' ').trim();
      li.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = '';
      });
      if (text) names.push(text);
    });
    if (!names.length) return;
    var line = document.createElement('p');
    line.className = 'v3-lulu__color-names';
    line.textContent = names.join(' / ');
    list.after(line);
  });

  var groups = root.querySelectorAll('.v3-lulu__group');
  var sectionGrids = [];
  var jumpNav = document.createElement('nav');
  jumpNav.className = 'v3-lulu__jumps';
  jumpNav.setAttribute('aria-label', 'Sections');
  var jumpButtons = [];
  var footButtons = [];
  var currentSection = 0;
  var pagerPrev;
  var pagerNext;
  var footPrev;
  var footNext;

  function markCurrent(list, index) {
    list.forEach(function (button, i) {
      var on = i === index;
      button.classList.toggle('is-current', on);
      if (on) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }

  function setJump(index) {
    markCurrent(jumpButtons, index);
    markCurrent(footButtons, index);
    var current = jumpButtons[index];
    if (current && jumpNav.scrollWidth > jumpNav.clientWidth) {
      var left = index === 0 ? 0 : current.offsetLeft - (jumpNav.clientWidth - current.offsetWidth) / 2;
      jumpNav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  function syncPager() {
    if (!pagerPrev || !pagerNext) return;
    var prev = jumpButtons[currentSection - 1];
    var next = jumpButtons[currentSection + 1];
    pagerPrev.hidden = !prev;
    pagerNext.hidden = !next;
    if (footPrev) setFootStep(footPrev, !!prev);
    if (footNext) setFootStep(footNext, !!next);
    if (prev) {
      pagerPrev.querySelector('span').textContent = 'Previous';
      pagerPrev.setAttribute('aria-label', 'Previous category, ' + jumpName(prev));
      if (footPrev) footPrev.setAttribute('aria-label', 'Previous category, ' + jumpName(prev));
    }
    if (next) {
      pagerNext.querySelector('span').textContent = 'Next';
      pagerNext.setAttribute('aria-label', 'Next category, ' + jumpName(next));
      if (footNext) footNext.setAttribute('aria-label', 'Next category, ' + jumpName(next));
    }
  }

  function jumpName(button) {
    var name = button.querySelector('.v3-lulu__jump-name');
    return (name ? name.textContent : button.textContent).trim();
  }

  function showSection(index) {
    currentSection = index;
    setJump(index);
    sectionGrids.forEach(function (grid, i) {
      var on = i === index;
      grid.hidden = !on;
      grid.classList.remove('is-shown');
      if (!on) return;
      void grid.offsetWidth;
      grid.classList.add('is-shown');
    });
    syncPager();
  }

  groups.forEach(function (heading, index) {
    heading.id = 'lulu-sec-' + index;
    var grid = heading.nextElementSibling;
    sectionGrids.push(grid);
    var button = document.createElement('button');
    button.type = 'button';
    if (index === 5 || index === 8) {
      var split = document.createElement('span');
      split.className = 'v3-lulu__split';
      split.setAttribute('aria-hidden', 'true');
      jumpNav.appendChild(split);
    }
    var whoText = index < 5 ? 'for women' : index < 8 ? 'for men' : '';
    if (whoText) {
      var who = document.createElement('span');
      who.className = 'v3-lulu__who';
      who.textContent = whoText;
      button.appendChild(who);
    }
    var name = document.createElement('span');
    name.className = 'v3-lulu__jump-name';
    name.textContent = heading.textContent.trim();
    button.appendChild(name);
    button.addEventListener('click', function () {
      if (button.classList.contains('is-current')) return;
      showSection(index);
    });
    jumpNav.appendChild(button);
    jumpButtons.push(button);
  });
  var firstPanel = root.querySelector('.v3-lulu__panel');
  if (firstPanel && jumpButtons.length) firstPanel.parentNode.insertBefore(jumpNav, firstPanel);

  var catalog = root.querySelector('.v3-lulu__catalog');
  if (catalog && jumpButtons.length > 1) {
    var pager = document.createElement('div');
    pager.className = 'v3-lulu__pager';
    function makePager(dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'v3-lulu__pager-btn';
      var icon = dir < 0
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>';
      button.innerHTML = dir < 0
        ? icon + '<span></span>'
        : '<span></span>' + icon;
      button.addEventListener('click', function () {
        var next = currentSection + dir;
        if (next < 0 || next >= jumpButtons.length) return;
        showSection(next);
        var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
        if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
        else window.scrollTo(0, Math.max(0, top));
      });
      return button;
    }
    pagerPrev = makePager(-1);
    pagerNext = makePager(1);
    var barSlot = document.getElementById('luluSelectBar');
    var midSlot = barSlot && barSlot.querySelector('.v3-lulu__bar-mid');
    if (barSlot && midSlot) {
      barSlot.insertBefore(pagerPrev, midSlot);
      barSlot.appendChild(pagerNext);
    }
    var footNav = document.createElement('nav');
    footNav.className = 'v3-lulu__jumps v3-lulu__jumps--foot';
    footNav.setAttribute('aria-label', 'Sections');
    groups.forEach(function (heading, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = heading.textContent.trim();
      button.addEventListener('click', function () {
        if (index === currentSection) return;
        showSection(index);
        var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
        if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
        else window.scrollTo(0, Math.max(0, top));
      });
      footNav.appendChild(button);
      footButtons.push(button);
    });
    pager.appendChild(footNav);
    catalog.appendChild(pager);
  }
  if (jumpButtons.length) showSection(0);

  root.querySelectorAll('[data-lulu-browse]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
  });

  var bar = document.getElementById('luluSelectBar');
  var grids = root.querySelectorAll('.v3-lulu__grid');
  if (bar && grids.length) {
    var barTicking = false;
    function syncBar() {
      var line = window.innerHeight * 0.62;
      var floor = window.innerHeight * 0.18;
      var show = false;
      grids.forEach(function (grid) {
        if (grid.hidden || grid.closest('[hidden]')) return;
        var rect = grid.getBoundingClientRect();
        if (rect.top < line && rect.bottom > floor) show = true;
      });
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    function onScroll() {
      if (barTicking) return;
      barTicking = true;
      requestAnimationFrame(function () {
        barTicking = false;
        syncBar();
      });
    }
    syncBar();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    function bindLenis(tries) {
      if (window.lenis && window.lenis.on) window.lenis.on('scroll', onScroll);
      else if (tries > 0) setTimeout(function () { bindLenis(tries - 1); }, 200);
    }
    bindLenis(15);
  }

  var cards = root.querySelectorAll('.v3-lulu__grid > li');
  var selected = new Set();
  var MAX = 24;
  var countEl = document.getElementById('luluCount');
  var addBtn = document.getElementById('luluAddSelected');
  var finishBtn = null;
  var pagerEl = root.querySelector('.v3-lulu__pager');
  if (addBtn && pagerEl) {
    finishBtn = addBtn.cloneNode(true);
    finishBtn.id = 'luluFinish';
    var finishLabel = finishBtn.querySelector('.v3-btn__label');
    if (finishLabel) finishLabel.textContent = 'Finish selection';
    var finishWrap = document.createElement('div');
    finishWrap.className = 'v3-lulu__finish';
    footPrev = document.createElement('button');
    footPrev.type = 'button';
    footPrev.className = 'v3-btn v3-lulu__finish-next v3-lulu__finish-prev';
    footPrev.textContent = 'Previous';
    footPrev.addEventListener('click', function () {
      var prev = currentSection - 1;
      if (prev < 0) return;
      showSection(prev);
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
    finishWrap.appendChild(footPrev);
    finishWrap.appendChild(finishBtn);
    footNext = document.createElement('button');
    footNext.type = 'button';
    footNext.className = 'v3-btn v3-lulu__finish-next';
    footNext.textContent = 'Next';
    footNext.addEventListener('click', function () {
      var next = currentSection + 1;
      if (next >= jumpButtons.length) return;
      showSection(next);
      var top = jumpNav.getBoundingClientRect().top + window.scrollY - 120;
      if (window.lenis) window.lenis.scrollTo(Math.max(0, top));
      else window.scrollTo(0, Math.max(0, top));
    });
    finishWrap.appendChild(footNext);
    setFootStep(footPrev, currentSection > 0);
    setFootStep(footNext, currentSection < jumpButtons.length - 1);
    pagerEl.appendChild(finishWrap);
  }

  function setFootStep(button, show) {
    if (!button) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      button.hidden = !show;
      button.classList.toggle('is-in', show);
      button.classList.remove('is-out');
      return;
    }
    if (show) {
      var staying = button.classList.contains('is-in') && !button.classList.contains('is-out') && !button.hidden;
      button.hidden = false;
      button.classList.remove('is-out');
      if (staying) return;
      void button.offsetWidth;
      button.classList.add('is-in');
      return;
    }
    if (button.hidden || button.classList.contains('is-out') || !button.classList.contains('is-in')) {
      button.hidden = true;
      return;
    }
    button.classList.remove('is-in');
    button.classList.add('is-out');
    var token = {};
    button._leave = token;
    button.addEventListener('transitionend', function done(event) {
      if (event.propertyName !== 'opacity' || button._leave !== token) return;
      button.hidden = true;
      button.classList.remove('is-out');
      button.removeEventListener('transitionend', done);
    });
  }

  cards.forEach(function (card, index) {
    card.classList.add('v3-lulu__shot');
    card.setAttribute('role', 'button');
    card.tabIndex = 0;
    card.setAttribute('aria-pressed', 'false');
    card.setAttribute('data-id', String(index + 1));
    var photo = card.querySelector('.v3-lulu__img');
    if (photo && !photo.querySelector('.v3-lulu__picked')) {
      var mark = document.createElement('span');
      mark.className = 'v3-lulu__picked';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = 'Selected';
      photo.appendChild(mark);
    }
  });

  function cardName(card) {
    var strong = card.querySelector('strong');
    return strong ? strong.textContent.trim() : '';
  }

  function updateCount() {
    var n = selected.size;
    if (countEl) {
      countEl.classList.toggle('is-wide', n >= 12);
      if (n === 0) {
        countEl.textContent = 'Click a product to select it, up to 12.';
      } else if (n === 12) {
        countEl.textContent = 'Finished. 12 items selected, click Finish selection.';
      } else if (n === MAX) {
        countEl.innerHTML = '24 items selected. Please <a href="mailto:wecare@inkdstores.com?subject=Full%20Lululemon%20catalog&amp;body=We%20want%20the%20full%20Lululemon%20catalog%20on%20our%20webstore.">email us</a> if you want more.';
      } else if (n > 12) {
        countEl.innerHTML = n + ' items selected. Want the full catalog? <a href="mailto:wecare@inkdstores.com?subject=Full%20Lululemon%20catalog&amp;body=We%20want%20the%20full%20Lululemon%20catalog%20on%20our%20webstore.">Email us</a>.';
      } else {
        countEl.textContent = n + (n === 1 ? ' item selected' : ' items selected');
      }
    }
    [addBtn, finishBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('is-disabled', n === 0);
      btn.disabled = n === 0;
    });
  }

  function toggle(card) {
    var id = card.getAttribute('data-id');
    if (selected.has(id)) {
      selected.delete(id);
      card.classList.remove('is-selected');
      void card.offsetWidth;
      card.classList.add('is-leaving');
      card.setAttribute('aria-pressed', 'false');
    } else if (selected.size < MAX) {
      selected.add(id);
      card.classList.remove('is-leaving');
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      updateCount();
      if (selected.size === 1 || selected.size % 6 === 0) nudgeSend();
      return;
    }
    updateCount();
  }

  function nudgeSend() {
    [addBtn, finishBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.remove('v3-lulu__nudge');
      void btn.offsetWidth;
      btn.classList.add('v3-lulu__nudge');
    });
  }

  root.addEventListener('click', function (event) {
    var card = event.target.closest('.v3-lulu__shot');
    if (!card || !root.contains(card)) return;
    toggle(card);
  });

  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest('.v3-lulu__shot');
    if (!card) return;
    event.preventDefault();
    toggle(card);
  });

  var formLayer = document.getElementById('luluForm');
  var form = document.getElementById('luluContactForm');
  var formWrap = document.getElementById('luluFormWrap');
  var success = document.getElementById('luluSuccess');
  var lede = document.getElementById('luluFormLede');
  var picker = document.getElementById('luluPicker');
  var formCount = document.getElementById('luluFormCount');
  var progress = document.getElementById('luluProgress');
  var progressFill = document.getElementById('luluProgressFill');
  var nextBtn = document.getElementById('luluNext');
  var formSteps = formLayer ? formLayer.querySelectorAll('.v3-lulu__step') : [];
  var stepLabels = formLayer ? formLayer.querySelectorAll('.v3-lulu__steps span') : [];
  var mode = 'selected';
  var formSelected = new Set();
  var currentStep = 1;

  function cardGroup(card) {
    var grid = card.closest('.v3-lulu__grid');
    var heading = grid && grid.previousElementSibling;
    return heading ? heading.textContent.trim() : 'Collection';
  }

  function cardImage(card) {
    var img = card.querySelector('img');
    return img ? img.getAttribute('src') : '';
  }

  function formCards() {
    var list = [];
    cards.forEach(function (card) {
      var id = card.getAttribute('data-id');
      if (mode === 'full' || selected.has(id)) list.push(card);
    });
    return list;
  }

  function syncFormCount() {
    var n = formSelected.size;
    if (formCount) formCount.textContent = n + '/' + MAX;
    if (nextBtn) nextBtn.disabled = n === 0;
  }

  function paintCard(card, on) {
    var id = card.getAttribute('data-id');
    if (on) {
      selected.add(id);
      card.classList.add('is-selected');
      card.classList.remove('is-leaving');
      card.setAttribute('aria-pressed', 'true');
    } else {
      selected.delete(id);
      card.classList.remove('is-selected');
      card.classList.add('is-leaving');
      card.setAttribute('aria-pressed', 'false');
    }
  }

  function renderPicker() {
    if (!picker) return;
    picker.innerHTML = '';
    var groups = [];
    var byName = {};
    cards.forEach(function (card) {
      var group = cardGroup(card);
      if (!byName[group]) {
        byName[group] = [];
        groups.push(group);
      }
      byName[group].push(card);
    });
    groups.forEach(function (group) {
      var items = byName[group].filter(function (card) {
        return formSelected.has(card.getAttribute('data-id'));
      });
      if (!items.length) return;
      var block = document.createElement('section');
      block.className = 'v3-lulu__pick-group is-open';
      var head = document.createElement('div');
      head.className = 'v3-lulu__pick-head';
      var toggle = document.createElement('div');
      toggle.className = 'v3-lulu__pick-toggle';
      var title = document.createElement('span');
      title.textContent = group;
      var tally = document.createElement('span');
      function groupOn() {
        return items.filter(function (card) {
          return formSelected.has(card.getAttribute('data-id'));
        }).length;
      }
      function writeTally() {
        tally.textContent = String(groupOn());
      }
      var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chevron.setAttribute('class', 'v3-lulu__pick-chevron');
      chevron.setAttribute('viewBox', '0 0 24 24');
      chevron.setAttribute('fill', 'none');
      chevron.setAttribute('aria-hidden', 'true');
      var chevronPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      chevronPath.setAttribute('d', 'M6 9l6 6 6-6');
      chevronPath.setAttribute('stroke', 'currentColor');
      chevronPath.setAttribute('stroke-width', '1.8');
      chevronPath.setAttribute('stroke-linecap', 'square');
      chevron.appendChild(chevronPath);
      var name = document.createElement('span');
      name.className = 'v3-lulu__pick-name';
      name.appendChild(title);
      name.appendChild(chevron);
      toggle.appendChild(name);
      toggle.appendChild(tally);
      head.appendChild(toggle);
      block.appendChild(head);
      items.forEach(function (card) {
        var id = card.getAttribute('data-id');
        var label = document.createElement('label');
        label.className = 'v3-lulu__pick';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.checked = formSelected.has(id);
        cb.addEventListener('change', function () {
          if (cb.checked) {
            cb.checked = false;
            return;
          }
          formSelected.delete(id);
          if (mode === 'selected') {
            paintCard(card, false);
            updateCount();
          }
          label.remove();
          if (groupOn() === 0) block.remove();
          else writeTally();
          syncFormCount();
        });
        var img = document.createElement('img');
        img.src = cardImage(card);
        img.alt = '';
        img.width = 44;
        img.height = 56;
        var span = document.createElement('span');
        span.textContent = cardName(card);
        label.appendChild(cb);
        label.appendChild(img);
        label.appendChild(span);
        block.appendChild(label);
      });
      writeTally();
      picker.appendChild(block);
    });
    syncFormCount();
  }

  function setStep(n) {
    currentStep = n;
    formSteps.forEach(function (step) {
      step.hidden = step.getAttribute('data-step') !== String(n);
    });
    if (nextBtn) nextBtn.hidden = n === 2;
    var submitBtn = document.getElementById('luluSubmit');
    if (submitBtn) submitBtn.hidden = n !== 2;
    if (formCount) formCount.hidden = n !== 1;
    if (progressFill) progressFill.style.width = (n === 1 ? '50%' : '100%');
    stepLabels.forEach(function (label, i) {
      label.classList.toggle('is-active', i < n);
    });
    if (formLayer) formLayer.scrollTop = 0;
  }

  function openForm(kind) {
    if (kind === 'selected' && selected.size === 0) return;
    mode = kind;
    formSelected = new Set();
    formCards().forEach(function (card) {
      formSelected.add(card.getAttribute('data-id'));
    });
    if (lede) {
      lede.textContent = 'Uncheck any piece you want to leave out.';
    }
    renderPicker();
    setStep(1);
    if (formWrap) formWrap.hidden = false;
    if (success) success.hidden = true;
    if (progress) progress.hidden = false;
    var intro = document.getElementById('luluFormIntro');
    if (intro) intro.hidden = false;
    if (formLayer) {
      formLayer.hidden = false;
      document.body.classList.add('v3-lulu-form-open');
    }
  }

  function closeForm() {
    if (formLayer) formLayer.hidden = true;
    document.body.classList.remove('v3-lulu-form-open');
  }

  root.querySelectorAll('[data-lulu-open]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openForm(btn.getAttribute('data-lulu-open'));
    });
  });

  var backBtn = document.getElementById('luluFormBack');
  var successClose = document.getElementById('luluSuccessClose');
  if (backBtn) backBtn.addEventListener('click', function () {
    if (currentStep > 1) {
      clearErrors();
      setStep(1);
      return;
    }
    closeForm();
  });
  if (successClose) successClose.addEventListener('click', closeForm);
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (formSelected.size === 0) return;
    setStep(2);
  });

  function clearErrors() {
    root.querySelectorAll('.v3-lulu__field.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });
  }

  function validate() {
    clearErrors();
    var name = document.getElementById('luluName').value.trim();
    var email = document.getElementById('luluEmail').value.trim();
    var store = document.getElementById('luluStore').value.trim();
    var ok = true;
    if (!name) { document.getElementById('luluNameField').classList.add('is-error'); ok = false; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      document.getElementById('luluEmailField').classList.add('is-error');
      ok = false;
    }
    if (!store) { document.getElementById('luluStoreField').classList.add('is-error'); ok = false; }
    return ok;
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (currentStep === 1) {
        if (formSelected.size === 0) return;
        setStep(2);
        return;
      }
      if (!validate()) return;
      var name = document.getElementById('luluName').value.trim();
      var email = document.getElementById('luluEmail').value.trim();
      var store = document.getElementById('luluStore').value.trim();
      var items = [];
      var lines = [];
      var lastGroup = '';
      formCards().forEach(function (card) {
        var id = card.getAttribute('data-id');
        if (!formSelected.has(id)) return;
        var nameLine = cardName(card);
        var group = cardGroup(card);
        items.push(group + ' — ' + nameLine);
        if (group !== lastGroup) {
          if (lines.length) lines.push('');
          lines.push(group);
          lastGroup = group;
        }
        lines.push('- ' + nameLine);
      });
      var details = (mode === 'full' ? 'Full collection' : 'Selected pieces') + ' (' + items.length + '):\n' + lines.join('\n') + '\n\n'
        + 'Name: ' + name + '\n'
        + 'Email: ' + email + '\n'
        + 'Webstore / Company: ' + store;
      var submitBtn = document.getElementById('luluSubmit');
      var label = submitBtn.querySelector('.v3-btn__label');
      var sendErr = document.getElementById('luluSubmitError');
      submitBtn.disabled = true;
      if (label) label.textContent = 'Sending...';
      if (sendErr) sendErr.hidden = true;

      fetch('https://lululemon.inkdstores.workers.dev/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name,
          email: email,
          store: store,
          items: items,
          total: cards.length,
          details: details,
          page: location.href
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('submit failed');
        if (progress) progress.hidden = true;
        if (formWrap) formWrap.hidden = true;
        var introDone = document.getElementById('luluFormIntro');
        if (introDone) introDone.hidden = true;
        if (success) success.hidden = false;
      }).catch(function () {
        submitBtn.disabled = false;
        if (label) label.textContent = 'Confirm & Add';
        if (sendErr) sendErr.hidden = false;
      });
    });
  }

  updateCount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkd-v3-project"]) return;
  try {
    
  const root = document.querySelector("[data-v3-project]");
  if (root) {
    const form = root.querySelector("form");
    const worker = root.getAttribute("data-worker") || "https://project.inkdstores.workers.dev/submit";
    const stages = [...root.querySelectorAll("[data-stage]")].filter((node) => node.getAttribute("data-stage") !== "done");
    const done = root.querySelector("[data-stage='done']");
    const needInput = root.querySelector("[data-need-input]");
    const serviceInput = root.querySelector("[data-service-input]");
    const brandInput = root.querySelector("[data-brand-input]");
    const categoryInput = root.querySelector("[data-category-input]");
    const pieceInput = root.querySelector("[data-piece-input]");
    const firstNameInput = root.querySelector("[data-first-name]");
    const lastNameInput = root.querySelector("[data-last-name]");
    const companyInput = root.querySelector("[data-company]");
    const emailInput = root.querySelector("[data-email]");
    const phoneInput = root.querySelector("[data-phone]");
    const detailsInput = root.querySelector("[data-details]");
    const chips = [...root.querySelectorAll("[data-need]")];
    const params = new URLSearchParams(window.location.search);
    const aliases = {
      "branded apparel": "Custom Apparel",
      "custom apparel & branded goods": "Custom Apparel",
      "custom apparel": "Custom Apparel",
      "bulk order": "Bulk Order",
      "bulk orders": "Bulk Order",
      "bulk-order": "Bulk Order",
      bulk: "Bulk Order",
      stores: "Company Store",
      store: "Company Store",
      "company store": "Company Store",
      "company stores": "Company Store",
      "company-store": "Company Store",
      kits: "Kits & Gifting",
      "kits & gifting": "Kits & Gifting",
      gifting: "Kits & Gifting",
      "new-hire kits": "Kits & Gifting",
      apparel: "Custom Apparel",
      bags: "Bags",
      drinkware: "Drinkware",
      headwear: "Headwear",
      hats: "Headwear",
      "still figuring it out": "Still Figuring It Out",
      figuring: "Still Figuring It Out",
      other: "Still Figuring It Out"
    };

    const valueOf = (input) => (input?.value || "").trim();
    const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const validPhone = (value) => value.replace(/\D/g, "").length >= 7;

    const normalizeNeed = (value) => {
      const raw = String(value || "").trim();
      if (!raw) return "";
      const mapped = aliases[raw.toLowerCase()];
      if (mapped) return mapped;
      const match = chips.find((chip) => (chip.getAttribute("data-need") || "").toLowerCase() === raw.toLowerCase());
      return match ? match.getAttribute("data-need") : raw;
    };

    const selectedNeeds = () => chips
      .filter((chip) => chip.classList.contains("is-on"))
      .map((chip) => chip.getAttribute("data-need"))
      .filter(Boolean);

    const selectedServices = () => chips
      .filter((chip) => chip.classList.contains("is-on") && chip.getAttribute("data-kind") === "service")
      .map((chip) => chip.getAttribute("data-need"))
      .filter(Boolean);

    const selectedProducts = () => chips
      .filter((chip) => chip.classList.contains("is-on") && chip.getAttribute("data-kind") === "product")
      .map((chip) => chip.getAttribute("data-need"))
      .filter(Boolean);

    const syncNeed = () => {
      if (needInput) needInput.value = selectedNeeds().join(", ");
    };

    const setChip = (label, on, kind) => {
      chips.forEach((chip) => {
        if (chip.getAttribute("data-need") !== label) return;
        if (kind && chip.getAttribute("data-kind") !== kind) return;
        chip.classList.toggle("is-on", on);
        chip.setAttribute("aria-pressed", on ? "true" : "false");
      });
      syncNeed();
    };

    const applyParamList = (raw) => {
      String(raw || "")
        .split(",")
        .map(normalizeNeed)
        .filter(Boolean)
        .forEach((label) => setChip(label, true));
    };

    if (brandInput && params.get("brand")) brandInput.value = params.get("brand");
    if (categoryInput && params.get("category")) categoryInput.value = params.get("category");
    if (pieceInput && params.get("piece")) pieceInput.value = params.get("piece");
    applyParamList(params.get("need") || params.get("service") || params.get("interest"));
    applyParamList(params.get("category"));
    if (serviceInput && !serviceInput.value) serviceInput.value = selectedServices().join(", ");

    root.querySelectorAll("[data-stage]").forEach((item) => {
      if ("inert" in item) item.inert = !item.classList.contains("is-on");
    });

    const hintFor = (stageEl, text) => {
      const hint = stageEl.querySelector("[data-hint]");
      if (!hint) return;
      hint.hidden = !text;
      hint.textContent = text || "";
    };

    const validate = (index) => {
      const stageEl = stages[index];
      if (index === 0) {
        const ok = selectedServices().length > 0;
        hintFor(stageEl, ok ? "" : "Pick everything that applies.");
        return ok;
      }
      if (index === 1) {
        const ok = Boolean(valueOf(firstNameInput) && valueOf(lastNameInput));
        hintFor(stageEl, ok ? "" : "First and last name, so we know who to ask for.");
        return ok;
      }
      if (index === 2) {
        const ok = Boolean(valueOf(companyInput));
        hintFor(stageEl, ok ? "" : "Company is enough.");
        return ok;
      }
      if (!validEmail(valueOf(emailInput))) {
        hintFor(stageEl, "Use a work email we can reply to.");
        return false;
      }
      if (!validPhone(valueOf(phoneInput))) {
        hintFor(stageEl, "Add a phone number so we can reach you.");
        return false;
      }
      hintFor(stageEl, "");
      return true;
    };

    const show = (node) => {
      if (!node) return;
      root.querySelectorAll("[data-stage]").forEach((item) => {
        const on = item === node;
        item.classList.toggle("is-on", on);
        if ("inert" in item) item.inert = !on;
      });
      const focusable = node.querySelector("input:not([type='hidden']), textarea, button[data-need]");
      focusable?.focus({ preventScroll: true });
    };

    const go = (index) => show(stages[index]);
    const showDone = () => show(done);

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        setChip(
          chip.getAttribute("data-need"),
          !chip.classList.contains("is-on"),
          chip.getAttribute("data-kind")
        );
        hintFor(chip.closest("[data-stage]"), "");
      });
    });

    root.querySelectorAll("[data-next]").forEach((button) => {
      button.addEventListener("click", () => {
        const stageEl = button.closest("[data-stage]");
        const index = stages.indexOf(stageEl);
        if (!validate(index)) return;
        go(index + 1);
      });
    });

    root.querySelectorAll("[data-back]").forEach((button) => {
      button.addEventListener("click", () => {
        const stageEl = button.closest("[data-stage]");
        const index = stages.indexOf(stageEl);
        if (index > 0) go(index - 1);
      });
    });

    form.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" || event.target.tagName === "TEXTAREA") return;
      const stageEl = event.target.closest("[data-stage]");
      const index = stages.indexOf(stageEl);
      if (index > -1 && index < 3) {
        event.preventDefault();
        if (validate(index)) go(index + 1);
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!validate(3)) return;
      syncNeed();
      const submitBtn = root.querySelector("[data-submit]");
      const label = submitBtn?.querySelector(".v3-btn__label");
      const restore = label?.textContent || "";
      if (submitBtn) submitBtn.disabled = true;
      if (label) label.textContent = "Sending...";
      try {
        const response = await fetch(worker, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            form: "project",
            firstName: valueOf(firstNameInput),
            lastName: valueOf(lastNameInput),
            company: valueOf(companyInput),
            email: valueOf(emailInput),
            phone: valueOf(phoneInput),
            need: selectedServices(),
            products: selectedProducts(),
            details: valueOf(detailsInput),
            page: window.location.href,
            brand: valueOf(brandInput),
            category: valueOf(categoryInput),
            service: selectedServices().join(", ")
          })
        });
        const payload = await response.json().catch(() => ({}));
        if (response.ok && payload.ok) {
          showDone();
          return;
        }
        throw new Error((payload && payload.error) || "submit failed");
      } catch (error) {
        if (submitBtn) submitBtn.disabled = false;
        if (label) label.textContent = restore;
        hintFor(stages[3], "Could not send. Try again or call (774) 215-0375.");
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
